import breakpoint from './breakpoint/index.mjs';
import opacity from './opacity/index.mjs';
import spacing from './spacing/index.mjs';
import zIndex from './z-index/index.mjs';
import atomic from './atomic/index.mjs';
import * as semantic from './semantic/index.mjs';

// src/theme/index.ts
var lightOriginTheme = {
  palette: {
    ...atomic,
    ...semantic.light
  },
  opacity,
  breakpoint,
  spacing,
  zIndex,
  platform: {
    ios: {
      navigation: `
        background-color: rgba(var(--palette-background-elevated-normal-rgb), 0.88);
        backdrop-filter: blur(32px);
      `
    }
  }
};
var darkOriginTheme = {
  palette: {
    ...atomic,
    ...semantic.dark
  },
  opacity,
  breakpoint,
  spacing,
  zIndex,
  platform: {
    ios: {
      navigation: `
        background-color: rgba(var(--palette-background-elevated-normal-rgb), 0.74);
        backdrop-filter: blur(32px);
      `
    }
  }
};
var addVarPrefix = (obj, prefix) => {
  const newObj = {};
  for (const key in obj) {
    const originPrefix = `${prefix}-${key}`;
    if (typeof obj[key] === "object") {
      newObj[key] = addVarPrefix(obj[key], originPrefix);
    } else if (typeof obj[key] === "string" && obj[key].startsWith("#")) {
      newObj[key] = `var(--${originPrefix})`;
    } else {
      newObj[key] = obj[key];
    }
  }
  return newObj;
};
var lightTheme = {
  ...lightOriginTheme,
  palette: {
    ...addVarPrefix(atomic, "palette"),
    ...addVarPrefix(semantic.light, "palette")
  }
};
var darkTheme = {
  ...darkOriginTheme,
  palette: {
    ...addVarPrefix(atomic, "palette"),
    ...addVarPrefix(semantic.dark, "palette")
  }
};
var theme = {
  light: lightTheme,
  dark: darkTheme
};

export { darkOriginTheme, darkTheme, lightOriginTheme, lightTheme, theme };
